import {Injectable} from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor, HttpErrorResponse
} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {Router} from '@angular/router';
import {CommonService} from './common.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private router: Router, private _service: CommonService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: any) => {
        if (error instanceof HttpErrorResponse && error.status === 401) {
          console.error('Unauthorized request detected (401). Redirecting to login.');
          // Redirect user to login page or handle token refresh logic
          this.logout();
        }
        return throwError(() => error);
      })
    );
  }

  logout() {
    const token = localStorage.getItem('userToken');
    if (token) {
      this._service.postRequestCreator({
        token: token
      }, 'logout', token).subscribe(data => {
        this.removeLocalStorageData();
        console.log('logout success');
      }, error => {
        console.log('Error', error);
        this.removeLocalStorageData();
      });
    } else {
      this.removeLocalStorageData();
    }
  }

  removeLocalStorageData() {
    localStorage.removeItem('userToken');
    localStorage.removeItem('userData');
    this.router.navigate(['/login']);

  }

}
